import { render, staticRenderFns } from "./MetricTrafficGoals.vue?vue&type=template&id=50f7ea8e&scoped=true&"
import script from "./MetricTrafficGoals.vue?vue&type=script&lang=js&"
export * from "./MetricTrafficGoals.vue?vue&type=script&lang=js&"
import style0 from "./MetricTrafficGoals.vue?vue&type=style&index=0&id=50f7ea8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f7ea8e",
  null
  
)

export default component.exports